exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-title[data-v-e29dbaa0]{margin-bottom:15px}.b-share[data-v-e29dbaa0]{position:absolute;right:21px;top:21px;width:84px;text-align:right}.b-share>[data-v-e29dbaa0]{margin-bottom:15px;display:inline-block}.b-share>[data-v-e29dbaa0]:last-child{margin-bottom:0}.b-share span[data-v-e29dbaa0]{width:84px;font-weight:400;font-style:normal;font-stretch:normal;color:#828282}.b-share--item[data-v-e29dbaa0],.b-share span[data-v-e29dbaa0]{font-family:MenoeGrotesquePro;font-size:14px;line-height:1.43;letter-spacing:normal}.b-share--item[data-v-e29dbaa0]{color:#fff}.b-share--item[data-v-e29dbaa0]:hover{color:hsla(0,0%,100%,.6)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e29dbaa0","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?indentedSyntax!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/includes/header.vue
// module id = 492
// module chunks = 0